/**
 * Impact Feature Routes — Donor Portal
 */
import type { RouteRecordRaw } from 'vue-router';

export const impactRoutes: RouteRecordRaw[] = [
  {
    path: '/impact',
    name: 'impact',
    component: () => import('./views/ImpactView.vue'),
    meta: {
      requiresAuth: false,
      title: 'Your Impact',
      breadcrumbs: [
        { label: 'nav.dashboard', to: '/dashboard' },
        { label: 'donor.impact.title' },
      ],
    },
  },
];
